export interface ElapsedParts {
  hours: number
  minutes: number
  seconds: number
}

export const splitElapsed = (elapsedMs: number): ElapsedParts => {
  const totalSeconds = Math.max(0, Math.floor(elapsedMs / 1000))

  return {
    hours: Math.floor(totalSeconds / 3600),
    minutes: Math.floor((totalSeconds % 3600) / 60),
    seconds: totalSeconds % 60,
  }
}
